export var headings = {
  mobile: {
    number_xl: {
      fontSize: "3.25rem",
      lineHeight: "3.5rem"
    },
    number_lg: {
      fontSize: "2.5rem",
      lineHeight: "3rem"
    },
    number_md: {
      fontSize: "1.5rem",
      lineHeight: "2rem"
    },
    xl: {
      fontSize: "1.5rem",
      lineHeight: "2rem"
    },
    lg: {
      fontSize: "1.375rem",
      lineHeight: "1.5rem"
    },
    md: {
      fontSize: "1.3125rem",
      lineHeight: "1.5rem"
    },
    sm: {
      fontSize: "1.1875rem",
      lineHeight: "1.5rem"
    },
    xs: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem"
    },
    xxs: {
      fontSize: "1.0625rem",
      lineHeight: "1.5rem"
    }
  },
  desktop: {
    number_xl: {
      fontSize: "5.125rem",
      lineHeight: "5.5rem"
    },
    number_lg: {
      fontSize: "3.25rem",
      lineHeight: "4rem"
    },
    number_md: {
      fontSize: "2rem",
      lineHeight: "2.5rem"
    },
    xl: {
      fontSize: "2rem",
      lineHeight: "2.5rem"
    },
    lg: {
      fontSize: "1.8125rem",
      lineHeight: "2rem"
    },
    md: {
      fontSize: "1.625rem",
      lineHeight: "2rem"
    },
    sm: {
      fontSize: "1.4375rem",
      lineHeight: "2rem"
    },
    xs: {
      fontSize: "1.25rem",
      lineHeight: "1.5rem"
    },
    xxs: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem"
    }
  }
};
export var text = {
  mobile: {
    number_xl: {
      fontSize: "3.25rem",
      lineHeight: "3.5rem"
    },
    number_lg: {
      fontSize: "2.5rem",
      lineHeight: "3rem"
    },
    number_md: {
      fontSize: "1.5rem",
      lineHeight: "2rem"
    },
    xl: {
      fontSize: "1.5rem",
      lineHeight: "2rem"
    },
    lg: {
      fontSize: "1.0625rem",
      lineHeight: "1.5rem"
    },
    md: {
      fontSize: "1rem",
      lineHeight: "1.5rem"
    },
    sm: {
      fontSize: "0.875rem",
      lineHeight: "1.5rem"
    },
    xs: {
      fontSize: "0.8125rem",
      lineHeight: "1rem"
    },
    xxs: {
      fontSize: "0.6875rem",
      lineHeight: "1rem"
    }
  },
  desktop: {
    number_xl: {
      fontSize: "5.125rem",
      lineHeight: "5.5rem"
    },
    number_lg: {
      fontSize: "3.25rem",
      lineHeight: "4rem"
    },
    number_md: {
      fontSize: "2rem",
      lineHeight: "2.5rem"
    },
    xl: {
      fontSize: "2rem",
      lineHeight: "2.5rem"
    },
    lg: {
      fontSize: "1.125rem",
      lineHeight: "1.5rem"
    },
    md: {
      fontSize: "1rem",
      lineHeight: "1.5rem"
    },
    sm: {
      fontSize: "0.875rem",
      lineHeight: "1.5rem"
    },
    xs: {
      fontSize: "0.8125rem",
      lineHeight: "1rem"
    },
    xxs: {
      fontSize: "0.6875rem",
      lineHeight: "1rem"
    }
  }
};
//# sourceMappingURL=sizes.js.map